import * as locales from 'date-fns/locale';
import { format, formatISO as dateFnsFormatISO, addDays } from 'date-fns';

export const formatMillisecondsToDateWithLocale = (
  milliseconds: number,
  localeCode = 'en-GB',
  outputFormat = 'dd MMM'
) => {
  // Normalize locale (e.g., en-GB → enGB, es → es, fr → fr)
  const normalizedCode = localeCode.replace('-', '');

  // Try exact match (e.g., 'enGB'), fallback to base (e.g., 'en')
  const locale =
    (locales as Record<string, Locale>)[normalizedCode] ||
    (locales as Record<string, Locale>)[localeCode.split('-')[0]] ||
    locales.enUS;

  return format(milliseconds, outputFormat, { locale });
};

export const formatISO = (date: Date) =>
  dateFnsFormatISO(date, { representation: 'date' });

export const addDaysToTimestamp = (timestamp: number, days: number): number => {
  const date = new Date(timestamp);
  const newDate = addDays(date, days);
  return newDate.getTime();
};

export const formatForHsaResultsPage = (date: number | Date): string =>
  format(date, 'yyyy-MM-dd');
